import { getAppName } from '../../lib/env';

const classNames = (...classes: (undefined | string | boolean)[]): string =>
  classes.filter((x) => x && x !== true).join(' ');

interface Props {
  minimal?: boolean;
}

export const SiteFooter = (props: Props) => {
  return (
    <footer className="bg-gray-100" aria-labelledby="footerHeading">
      <div
        className={classNames(
          'border-t border-gray-200 pb-6',
          !props.minimal && 'mt-12 pt-8',
          props.minimal && 'mt-4 pt-4'
        )}
      >
        <p className="text-base text-gray-400 text-center">
          &copy; 2021-2024 {getAppName()}, Inc. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
